import { render, staticRenderFns } from "./PurpleCheckbox.vue?vue&type=template&id=298b2668&scoped=true"
import script from "./PurpleCheckbox.vue?vue&type=script&lang=js"
export * from "./PurpleCheckbox.vue?vue&type=script&lang=js"
import style0 from "./PurpleCheckbox.vue?vue&type=style&index=0&id=298b2668&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298b2668",
  null
  
)

export default component.exports